import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import notificationAction from "../../redux/notification/action";
import { notify } from "../../utils/toast";

const Notifications = () => {
  const dispatch = useDispatch();

  // Fetch notifications from Redux
  const notifications = useSelector(
    (state) => state.notificationReducer?.notifications || []
  );

  const [data, setData] = useState([]);

  useEffect(() => {
    // Sync with Redux state
    setData(notifications);
  }, [notifications]);

  const markAsRead = (id) => {
    try {
      dispatch(notificationAction.markAsRead(id));
      notify.success("Notification marked as read!");
    } catch (error) {
      notify.error("Something went wrong!");
    }
  };

  const clearAllNotifications = () => {
    try {
      dispatch(notificationAction.clearNotifications());
      notify.success("All notifications cleared!");
    } catch (error) {
      notify.error("Something went wrong!");
    }
  };

  return (
    <>
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <div className="d-flex justify-content-between align-items-center">
              <h3>Notifications</h3>
              {data.length > 0 && (
                <div
                  className="themeBtn px-3 py-1 cursor-pointer"
                  onClick={clearAllNotifications}
                >
                  Clear All
                </div>
              )}
            </div>
            <Table data={data} markAsRead={markAsRead} />
          </div>
        </div>
      </div>
    </>
  );
};

const Table = ({ data, markAsRead }) => {
  const formatDate = (date) => {
    return moment(date).format("MMMM Do YYYY, h:mm:ss a");
  };

  return (
    <div className="TableMain mt-3">
      <div className="table-responsive">
        <table className="table table-hover drivers-table">
          <thead>
            <tr>
              <th scope="col">Title</th>
              <th scope="col">Description</th>
              {/* <th scope="col">Email</th> */}
              <th scope="col">Type</th>
              <th scope="col">Created At</th>
              <th scope="col">Status</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center text-muted">
                  No notifications available
                </td>
              </tr>
            ) : (
              data.map((item, key) => (
                <tr key={key} className={item.read ? "text-muted" : ""}>
                  <td>{item?.title}</td>
                  <td>{item?.description}</td>
                  {/* <td>{item?.details?.employeeEmail || "-"}</td>{" "} */}
                  <td>
                    <span className={`badge bg-${getBadgeColor(item?.type)}`}>
                      {item?.type || "info"}
                    </span>
                  </td>
                  <td>
                    {item?.details?.updatedAt
                      ? formatDate(item.details.updatedAt)
                      : item?.createdAt
                      ? formatDate(item.createdAt)
                      : "-"}
                  </td>
                  <td>{item?.read ? "Read" : "Unread"}</td>
                  <td>
                    {!item.read && (
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => markAsRead(item?.id)}
                      >
                        Mark as Read
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Helper
const getBadgeColor = (type) => {
  const colors = {
    success: "success",
    error: "danger",
    warning: "warning",
    info: "info",
  };
  return colors[type] || "secondary";
};

export default Notifications;
